// Introducing the method of registering components
import { withInstall } from '@/utils';
// Introducing Components
import nav from './Navigator.vue';
// Throw component
export const AmzNav = withInstall(nav, 'AmzNav');
